export enum CategoryTreeIdType {
  Cat = 'CAT',
  Sol = 'SOL',
}
